import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
export default function Onboarding() {
    const { id } = useParams();
    const [csrfToken, setCsrfToken] = useState(null);
    const [athlete, setAthlete] = useState(null);
    const [nickname, setNickname] = useState("");
    const [eventFilters, setEventFilters] = useState("");
    const [trainingFilters, setTrainingFilters] = useState("");

    const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:4001";
    useEffect(() => {
        fetch(`${API}/athletes/${id}`)
            .then(r => r.json())
            .then(data => {
                setAthlete(data);
                setNickname(data.nickname || "");
                setEventFilters((data.eventFilters || []).join(","));
                setTrainingFilters((data.trainingFilters || []).join(","));
            });
    }, [id]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
            credentials: "include"
        })
            .then(r => r.json())
            .then(data => setCsrfToken(data.csrfToken));
    }, []);



    const save = () => {
        console.log("Saving onboarding data:", { nickname, eventFilters, trainingFilters });
        console.log("CSRF Token:", csrfToken);
        fetch(`${API}/athletes/${id}/onboarding`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "CSRF-Token": csrfToken
            },
            body: JSON.stringify({
                nickname,
                eventFilters: eventFilters.split(","),
                trainingFilters: trainingFilters.split(",")
            })
        })
            .then(r => r.json())
            .then(() => {
                // Handle success, e.g., show a success message or redirect
            });
    };

    return (
        <div>
            <h1>Onboarding</h1>
            <label htmlFor="nickname">Nickname</label>
            <input
                value={nickname}
                onChange={e => setNickname(e.target.value)}
                placeholder="Naam / nickname"
            />

            <label htmlFor="eventFilters">Event Filter</label>
            <input
                value={eventFilters}
                onChange={e => setEventFilters(e.target.value)}
                placeholder="Event filter"
            />

            <label htmlFor="trainingFilters">Training Filter</label>
            <input
                value={trainingFilters}
                onChange={e => setTrainingFilters(e.target.value)}
                placeholder="Training filter"
            />

            <button onClick={save}>Opslaan</button>
        </div>
    );
}